(function () {
  function eculabGuide(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var MODES = { O: 'OBD', B: 'BENCH', T: 'BOOT', D: 'BDM', J: 'JTAG', N: 'NBD' };
    var TOOLMAP = { kess: 'kess', ktag: 'ktag', kdcan: 'kdcan', enet: 'enet', kt200: 'kt200', kt200ii: 'kt200ii', mpps: 'mpps' };
    var steps = root.querySelectorAll('[data-step]');
    var crumbs = root.querySelector('[data-crumbs]');
    var restart = root.querySelector('[data-restart]');
    var tpl = root.querySelector('[data-templates]');
    var path = [];
    var DATA = null;

    function card(id, modes) {
      var src = tpl.querySelector('[data-card="' + id + '"]');
      if (!src) return null;
      var c = src.cloneNode(true);
      var m = c.querySelector('[data-modes]');
      if (modes !== undefined) {
        if (!modes) { c.classList.add('is-off'); m.innerHTML = '<span class="is-no">Non compatible</span>'; }
        else {
          m.innerHTML = modes.split('').map(function (k) { return '<span>' + (MODES[k] || k) + '</span>'; }).join('');
          var bd = c.querySelector('.eculab-guide__badge');
          if (bd) bd.textContent = modes.split('').map(function (k) { return MODES[k] || k; }).join(' · ');
        }
      }
      return c;
    }
    function fill(box) {
      if (box.dataset.filled) return;
      box.dataset.filled = '1';
      box.dataset.cards.split(',').forEach(function (id) { var c = card(id); if (c) box.appendChild(c); });
    }
    function show(name, label) {
      steps.forEach(function (s) { s.hidden = s.dataset.step !== name; });
      var cur = root.querySelector('[data-step="' + name + '"]');
      cur.querySelectorAll('[data-cards]').forEach(fill);
      if (label) path.push(label);
      crumbs.innerHTML = ['Guide'].concat(path).map(function (p) { return '<li>' + p + '</li>'; }).join('');
      restart.hidden = name === 'start';
      if (name === 'reprog') loadData();
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-go]');
      if (b) { show(b.dataset.go, b.dataset.label); }
      if (e.target.closest('[data-restart]')) { path = []; show('start'); }
    });

    /* Vehicle data: {"brands":[["Audi",[["A3 (8V)",[["2.0 TDI 150 ch","EDC17C64",{"kess":"O","ktag":"BT"}]]]]]]} */
    var selB = root.querySelector('[data-sel="brand"]'), selM = root.querySelector('[data-sel="model"]'), selE = root.querySelector('[data-sel="engine"]');
    var res = root.querySelector('[data-vehres]');
    function opts(sel, list, withEcu) { sel.innerHTML = '<option value="">Choisir…</option>' + list.map(function (x, i) { return '<option value="' + i + '">' + x[0] + (withEcu && x[1] ? ' — ' + x[1] : '') + '</option>'; }).join(''); sel.disabled = !list.length; }
    function loadData() {
      var url = root.dataset.dataUrl;
      if (!url || DATA) return;
      fetch(url).then(function (r) { return r.json(); }).then(function (d) {
        DATA = d;
        opts(selB, d.brands || []);
        root.querySelector('[data-vehicle]').hidden = false;
        root.querySelector('[data-vehicle-pending]').hidden = true;
        var g = root.querySelector('[data-reprog-general]'); if (g) g.hidden = true;
      }).catch(function () {});
    }
    selB.addEventListener('change', function () { opts(selM, selB.value ? DATA.brands[selB.value][1] : []); opts(selE, []); res.hidden = true; });
    selM.addEventListener('change', function () { opts(selE, selM.value ? DATA.brands[selB.value][1][selM.value][1] : [], true); res.hidden = true; });
    selE.addEventListener('change', function () {
      res.innerHTML = '';
      if (!selE.value) { res.hidden = true; return; }
      var e = DATA.brands[selB.value][1][selM.value][1][selE.value];
      var tools = e[2] || {};
      var head = document.createElement('p');
      head.className = 'eculab-guide__sub';
      head.textContent = 'Compatibilité' + (e[1] ? ' · calculateur ' + e[1] : '');
      res.appendChild(head);
      var grid = document.createElement('div');
      grid.className = 'eculab-guide__cards';
      var ids = Object.keys(TOOLMAP);
      ids.sort(function (a, b) { return (tools[b] ? 1 : 0) - (tools[a] ? 1 : 0); });
      var core = DATA.core || DATA.tools || [];
      ids.forEach(function (id) { if (DATA.tools && DATA.tools.indexOf(id) < 0) return; if (!tools[id] && core.indexOf(id) < 0) return; var c = card(id, tools[id] || ''); if (c) grid.appendChild(c); });
      res.appendChild(grid);
      var n = document.createElement('p');
      n.className = 'eculab-guide__note';
      var bmwTxt = (tools.kdcan || tools.enet) ? ' ' + (tools.kdcan ? 'Câble K+DCAN' : 'Câble ENET') + ' : reprogrammation BMW / MINI par la prise OBD, avec un logiciel de flash compatible.' : '';
      n.textContent = Object.keys(tools).length ? 'OBD : par la prise diagnostic, sans démonter le calculateur. Bench, Boot, BDM, JTAG : calculateur démonté, sur table. Les outils grisés ne prennent pas en charge ce calculateur.' + bmwTxt + ' Liste indicative : demandez-nous confirmation avant de commander.' : 'Ce véhicule n’est pas pris en charge par nos interfaces d’après les listes de compatibilité. Contactez-nous : d’autres solutions existent peut-être.';
      res.appendChild(n);
      res.hidden = false;
    });

    show('start');

    /* Lien direct vers l'étape « Reprogrammer » (#reprogrammer, ex. bouton du héros) */
    function goReprog(scroll) {
      path = []; show('reprog', 'Reprogrammer');
      if (scroll) window.scrollTo({ top: root.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
    }
    if (location.hash === '#reprogrammer') { goReprog(false); setTimeout(function () { goReprog(true); }, 400); }
    window.addEventListener('hashchange', function () { if (location.hash === '#reprogrammer') goReprog(false); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href$="#reprogrammer"]');
      if (!a) return;
      e.preventDefault();
      if (history.replaceState) history.replaceState(null, '', '#reprogrammer');
      goReprog(true);
    });
  }
  document.querySelectorAll('.eculab-guide').forEach(eculabGuide);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('.eculab-guide').forEach(eculabGuide); });
})();
